import CourseIntroForm from "./form/courseIntroForm"

const CourseIntro = () => {
    return (
        <div className="text-white">
            <CourseIntroForm></CourseIntroForm>
        </div>
    )
}
export default CourseIntro